export class UiValue {
  refnr: number = 0;
  value: number = 0;
  flags: number = 0;
}

export class Scale {
  minScale: number = -100;
  maxScale: number = +100;
}

export class Type {
  type: number = 0;
}

export class Variable {
  ui: string = "";
  text: string = "";
  id: number = 0;
  ref16: number = 0;
  format: string = "";
  precision: number = 0;
  unitnr: number = 0;
  unit: string = "";
}

export interface Textvalue {
  text: string;
  value: number;
}

export class ConstValue {
  value: number = 0;
  description: string = "";
}

export class Line {
  type: number = 0;
  typestring: string = "";
  variable: Variable = new Variable();
  textvalues: Textvalue[] = Array();
}

export class Target {
  type: number = 0;
  typestring: string = "";
  variable: Variable = new Variable();
}

export class Actual {
  type: number = 0;
  typestring: string = "";
  variable: Variable = new Variable();
}
export class ComplexObject {
  type: number   = 0;
  scale: Scale   = new Scale();
  actual: Actual = new Actual();
  target: Target = new Target();
  status: string = "";
}

export interface Line {
  type: number;
  typestring: string;
  variable: Variable;
  constvalue: ConstValue;
  textvalues: Textvalue[];
}

export interface BranchConstant {
  type: number;
  typestring: string;
  constvalue: ConstValue;
}

export interface BranchMeasurement {
  type: number;
  typestring: string;
  variable: Variable;
}

export class JSONCard {
  name: string = "nn";
  type: string = "-1";
  id: number = -1;
  alert: string = "none";
  base: number = 0;
  complexObjects: ComplexObject[] = Array();
  lines: Line[] = Array();
  branches: any[] = Array();  // This is a special struct for the component. (Like SingleValveStruct
}

export interface JSONCards {
  JSONCards: JSONCard[];
}


